var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBackSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_533_1329",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 1025
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.276855,
    width: 1440,
    height: 1024,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_533_1329)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-42 275.947C-42 275.947 144.525 323.295 350.083 166C555.641 8.70515 679.732 -80.4342 728.169 22.2544C776.606 124.943 554.539 286.952 435.011 432.432C315.483 577.912 287.802 471.141 375.247 376.716C462.691 282.291 681.616 70.9675 558.313 110.092C435.011 149.216 -42 516.777 -42 669.971C-42 823.165 415.215 644.812 633.972 427.231C852.729 209.651 826.891 -95.6401 1004 -151.207C1181.1 -206.775 975.403 248.222 675.325 513.758C375.247 779.295 139.839 923.52 139.839 1162.82C139.839 1402.12 412.734 1371.8 651.175 1162.82C889.617 953.841 1095.75 718.782 1106.96 534.912C1118.17 351.043 911.398 824.501 728.169 940.25C544.94 1056 407.33 1103.13 407.33 931.336C407.33 759.546 669.034 740.302 860.279 533.282C1051.52 326.263 1051.55 166 1155.8 166C1260.06 166 1317.22 -286 1111.92 -286C906.608 -286 604 68.0417 8.06678 110.092",
    stroke: "#29CC8B",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackSvg);
export default __webpack_public_path__ + "static/media/loginBackSvg.1eafcaaaeeed77153bd425a278c8ccde.svg";
export { ForwardRef as ReactComponent };